export default function Documentation() {
  const documents = [
    {
      icon: 'ri-file-text-line',
      title: 'Паспорт изделия'
    },
    {
      icon: 'ri-award-line',
      title: 'Сертификат ТР ТС'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Руководство по эксплуатации'
    },
    {
      icon: 'ri-draft-line',
      title: 'Чертежи'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-8 sm:mb-10 lg:mb-12">Документация и соответствие</h2>
        
        <div className="grid grid-cols-2 sm:flex sm:justify-center gap-8 sm:gap-12 lg:gap-16 mb-8">
          {documents.map((item, index) => (
            <div key={index} className="flex flex-col items-center">
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-[#1A2B4A] text-4xl sm:text-5xl`}></i>
              </div>
              <span className="text-xs sm:text-[15px] text-gray-700 text-center">{item.title}</span>
            </div>
          ))}
        </div>

        <p className="text-sm text-gray-600 text-center max-w-[600px] mx-auto px-4">
          Вся продукция поставляется с комплектом технической документации
        </p>
      </div>
    </section>
  );
}